import catchAsync from "../../utils/catchAsync";
import { handleSessionExpired } from "../../utils/sessionExpired";
import http from "./http";

export const refreshLoggedInUser = catchAsync(async (refreshToken) => {
  return http
    .post("/auth/refresh-tokens", refreshToken)
    .then((tokenData) => {
      if (tokenData?.access?.token && tokenData?.refresh?.token) {
        setSession(tokenData);
        return tokenData;
      }
      handleSessionExpired();
      return false;
    })
    .catch(() => {
      handleSessionExpired();
      return false;
    });
});

/**
 * *Set Session Fot User
 * @param {object} tokens
 */
const setSession = (tokens) => {
  if (tokens) {
    const { access, refresh } = tokens;
    if (access && refresh) {
      sessionStorage.setItem("_t", access.token);
      sessionStorage.setItem("_rt", refresh.token);
      if (localStorage.getItem("_t") || localStorage.getItem("_rt")) {
        localStorage.setItem("_t", access.token);
        localStorage.setItem("_rt", refresh.token);
      }
    }
  } else {
    sessionStorage.removeItem("_t");
    sessionStorage.removeItem("_rt");
    sessionStorage.removeItem("_e");
  }
};
const setLocalStorage = (tokens) => {
  if (tokens) {
    const { access, refresh } = tokens;
    if (access && refresh) {
      localStorage.setItem("_t", access.token);
      localStorage.setItem("_rt", refresh.token);
      // localStorage.setItem("_e", addDateTime(new Date(), "minute", 29));
    }
  } else {
    localStorage.removeItem("_t");
    localStorage.removeItem("_rt");
    localStorage.removeItem("_e");
  }
};

/**
 * *User login API.
 * @function ({{email: string, password: string}} values)
 * @returns {object}
 */
//login section
export const userLogin = catchAsync(async (values, rememberMe) => {
  const data = await http.post("/auth/signin", values);
  if (data && data?.serverResponse?.code === 200) {
    if (rememberMe) {
      setLocalStorage(data?.result?.tokens)
      setSession(data?.result?.tokens);
    }
    else {
      setSession(data?.result?.tokens);
    }
  }
  return data;
});
// user logout functio
export const userLogout = () => {
  setSession(null);
  setLocalStorage(null);
  clearStorage();
};
/**
 * Clear local storage
 */
const clearStorage = () => {
  localStorage.removeItem("persist:ohc");
};
// sign up section
export const userSignUp = catchAsync(async (values) => {
  const data = await http.post("/auth/signup", values);

  return data;
});
export const userForgotPass = catchAsync(async (values) => {
  const data = await http.post("/auth/forgot-password", values);

  return data;
});

export const userOtpVerify = catchAsync(async (values) => {
  const data = await http.post("/auth/verify-otp", values);

  return data;
});
export const userResetPass = catchAsync(async (values) => {
  let { apiData, paramToken } = values;
  let passwordData = apiData;
  const data = await http.post(`/auth/reset-password`, passwordData);

  return data;
});
export const gettingAllPostalSectorsApi = catchAsync(async () => {
  const data = await http.get(`/auth/postal-sectors`);

  return data;
});

// Social Sign in section starts here

// 1. First check that the user is available on the server 

export const checkUserAvailability = catchAsync(async (value) => {
  const user = await http.post('/auth/social-check', value)
  return user
})

// 2. Socail login section

export const socailLoginApi = catchAsync(async (value) => {
  const loginData = await http.post('/auth/social-signin', value)
  setSession(loginData?.result?.tokens);
  return loginData
})